import NavBar from './components/NavBar';
import HeroSection from './components/HeroSection';
import MessageSection from './components/MessageSection';
import ConcernsSection from './components/ConcernsSection';
import EmpathyBridgeSection from './components/EmpathyBridgeSection';
import WhySection from './components/WhySection';
import BusinessSection from './components/BusinessSection';
import CompanySection from './components/CompanySection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import BackToTopButton from './components/BackToTopButton';

export default function Home() {
  // min-h-screen(100vh) はモバイルで URL バーとずれるため dvh に統一
  return (
    <div className="w-full min-h-dvh" style={{ backgroundColor: '#FAF8F3' }}>
      <NavBar />
      <main>
        <HeroSection />
        <ConcernsSection />
        <EmpathyBridgeSection />
        <WhySection />
        <BusinessSection />
        <MessageSection />
        <CompanySection />
        <CTASection />
      </main>
      <Footer />
      <BackToTopButton />
    </div>
  );
}
